import {
  Flex,
  Text,
  CloseButton,
  Box,
  Center,
  FlexProps,
} from "@chakra-ui/react";
import { IoIosAlert } from "react-icons/io";

interface Props extends FlexProps {
  text: string;
  closeBanner: () => void;
  showIcon: boolean;
}

const Banner = ({ text, closeBanner, showIcon, ...rest }: Props) => {
  return (
    <Flex
      p="0.5rem"
      w="100%"
      bg="brand.primary"
      textColor="brand.textLight"
      fontFamily="medium"
      alignItems="center"
      position="fixed"
      zIndex={1000}
      {...rest}
    >
      <Center flexGrow={1}>
        {showIcon && (
          <Box fontSize={{ base: "2rem", md: "1.5rem" }}>
            <IoIosAlert />
          </Box>
        )}
        <Text textAlign="center" ml="0.5rem">
          <Text as="span" mr="0.5rem">
            {text}{" "}
          </Text>
        </Text>
      </Center>

      <CloseButton onClick={closeBanner} />
    </Flex>
  );
};

export default Banner;
